import React, { useState, useRef, useEffect } from "react"
import { TabView, TabPanel } from "primereact/tabview"
import { CardBody, Col, Container, Row, DropdownItem, DropdownMenu, } from "reactstrap"
// import { Col, Row } from "reactstrap"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import "primereact/resources/themes/saga-blue/theme.css"
import "primereact/resources/primereact.min.css"
import "primeicons/primeicons.css"
import { Dialog } from "primereact/dialog"
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"
import { Dropdown } from "primereact/dropdown"
import { BreadCrumb } from "primereact/breadcrumb"
import { RadioButton } from "primereact/radiobutton"
import { Checkbox } from "primereact/checkbox"
import Modal from "react-bootstrap/Modal";
import gdrive from "../../assets/images/google-drive.png"
import dropbox from "../../assets/images/dropbox.png"
import onedrive from "../../assets/images/one-drive.png"
import { Radius } from "lucide-react"
import { Controller, useForm } from "react-hook-form"
import { emailValidation, MaxLengthValidation, MinLengthValidation, onlyAlphabetsandSpaces, onlyNumbers, passwordPattern } from "utils/Constants"
import axios from "axios"
import moment from "moment"
import { triggerAlert, ConfirmationAlert } from "utils/CommonFunctions"

const Settingadm = () => {
    const [selectedOption, setSelectedOption] = useState(null)
    const [selectedOption1, setSelectedOption1] = useState(null)
    const [selectedOption2, setSelectedOption2] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [visible1, setVisible1] = useState(false)
    const [street1, setStreet1] = useState('');
    const [street2, setStreet2] = useState('')
    const [selectedCity, setSelectedCity] = useState(null);
    const [addCountries, setAddCountries] = useState([]);
    const [addStates, setAddStates] = useState([]);
    const [addCities, setaddCities] = useState([]);
    const [selectedState, setSelectedState] = useState(null)
    const [postalCode, setPostalCode] = useState('');
    const [userRoles, setUserRoles] = useState([])
    const [allCompanies, setAllCompanies] = useState([]);
    const [allDepartments, setAllDepartments] = useState([])
    const [companyItem, setCompanyItem] = useState([])
    const [selectedLabel1, setSelectedLabel1] = useState(null);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [groupitem, setgroupitem] = useState([])
    const [selectedGroupKey, setSelectedGroupKey] = useState(null);
    const [categoriesitem, setcategoriesitem] = useState([])

    const { register, handleSubmit, watch, formState: { errors }, trigger, control, setValue, reset } = useForm();

    // const [selectedOptionReports, setSelectedOptionReports] = useState(null)

    // Tracks the selected option
    const [users] = useState([
        {
            id: 1,
            name: "John Doe",
            username: "johndoe",
            password: "password123",
            status: "Active",
            archive: false,
            userRole: "Admin",
            email: "john@example.com",
        },

    ])

    const [userRole] = useState([
        {
            id: 1,
            username: "johndoe",
            password: "Developer",
        },
    ])

    const [isDialogVisible, setDialogVisible] = useState(false) // Controls Dialog visibility
    const [selectedUser, setSelectedUser] = useState(null) // Holds selected user for editing

    const handleEdit = user => {
        setSelectedUser(user) // Set selected user for editing
        setDialogVisible(true) // Show dialog
    }

    const handleSave = () => {
        // Logic to save the edited data
        setDialogVisible(false) // Close dialog
    }

    const handleCancel = () => {
        setDialogVisible(false) // Close dialog without saving
    }

    const editIcon = rowData => {
        return (
            <Button
                icon="pi pi-pencil"
                className="p-button-rounded p-button-warning"
                onClick={() => handleEdit(rowData)}
            />
        )
    }
    const deleteIcon = rowData => {
        return (
            <Button icon="pi pi-trash" className="p-button-rounded p-button-info" />
        )
    }
    const breadItems = [{ label: "User Permission" }, { label: "User List" }]
    const breadGeneral = [{ label: "settings" }, { label: "General" }]
    const breadDatabase = [{ label: "settings" }, { label: "Database Alerts" }]


    const menuLeft = useRef(null)
    const [visible, setVisible] = useState(false)

    const [fontSize, setFontSize] = useState("normal")
    const fontSizeOptions = [
        { label: "Extra Small", value: "10px" },
        { label: "Small", value: "12px" },
        { label: "Normal", value: "16px" },
        { label: "Large", value: "20px" },
    ]

    const [selectedFolder, setSelectedFolder] = useState(null)

    const folderOptions = [
        { label: "Dashboards", value: "dashboards", icon: "pi pi-th-large" },
        { label: "Reports", value: "reports", icon: "pi pi-chart-line" },
        { label: "Jobs", value: "jobs", icon: "pi pi-briefcase" },
        { label: "Candidates", value: "candidates", icon: "pi pi-users" },
        { label: "Candidate Pipeline", value: "pipeline", icon: "pi pi-sitemap" },
        { label: "Companies", value: "companies", icon: "pi pi-building" },
        { label: "Contacts", value: "contacts", icon: "pi pi-address-book" },
        { label: "Calendar", value: "calendar", icon: "pi pi-calendar" },
        { label: "Emails", value: "emails", icon: "pi pi-envelope" },
        { label: "Onboarding", value: "onboarding", icon: "pi pi-user-plus" },
        { label: "Admin Module", value: "admin", icon: "pi pi-user" },
    ]
    const customTemplate = option => {
        return (
            <div className="flex align-items-center">
                <i className={`${option.icon} mr-2`}></i>
                <span>{option.label}</span>
            </div>
        )
    }
    const [selectedView, setSelectedView] = useState(null)

    const viewOptions = [
        { label: "Home", value: "home" },
        { label: "Recruiters Dashboard", value: "recruiters_dashboard" },
    ]
    const [ingredient, setIngredient] = useState("")
    const [addsmtp, setAddsmtp] = useState("")
    const [outgoingServer, setOutgoingServer] = useState("")
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [fromEmail, setFromEmail] = useState("")
    const [email, setEmail] = useState("")
    const [port, setPort] = useState("")
    const [address, setAddress] = useState("")
    const [useSSL, setUseSSL] = useState(false)
    const [areaCode, setAreaCode] = useState("")
    const [accountKey, setAccountKey] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")

    // State for storing SMTP details
    const [smtpAccounts, setSmtpAccounts] = useState([])

    // Handle Create button click
    const handleCreate = () => {
        // Add current form data to smtpAccounts array
        const newAccount = {
            outgoingServer,
            port,
            username,
            password,
            email,
            address,
            useSSL,
        }

        setSmtpAccounts([...smtpAccounts, newAccount])

        // Clear form fields after creating
        setOutgoingServer("")
        setPort("")
        setUsername("")
        setPassword("")
        setFromEmail("")
        setEmail("")
        setAddress("")
        setUseSSL(false)
    }

    // user management start

    const [showPassword, setShowPassword] = useState(false)

    const [userList, setUserList] = useState([])

    const [formVisible, setFormVisible] = useState(false) // Controls the form visibility
    const [formData, setFormData] = useState({
        username: "",
        email: "",
        role: "",
        status: "Active", // Default status
        createDate: new Date().toISOString().split("T")[0], // Default to today's date
        password: "", // Password field
    })
    const [isEditMode, setIsEditMode] = useState(null) // True when editing, false when adding
    const [currentIndex, setCurrentIndex] = useState(null) // To track the index of the user being edited


    // Reset form after submit or cancel
    const resetForm = () => {
        reset()
        setFormVisible(false) // Hide the form
        setIsEditMode(null)
    }

    const [nodes, setNodes] = useState([]);
    // Function to create a new node
    const createNode = (parentId = null) => {
        const newNode = {
            key: Date.now().toString(),
            label: '',
            parentId,
            children: []
        };

        if (!parentId) {
            setNodes([...nodes, newNode]);
        } else {
            const updateNodes = (nodesList) => {
                return nodesList.map(node => {
                    if (node.key === parentId) {
                        return {
                            ...node,
                            children: [...(node.children || []), newNode]
                        };
                    }
                    if (node.children && node.children.length > 0) {
                        return {
                            ...node,
                            children: updateNodes(node.children)
                        };
                    }
                    return node;
                });
            };
            setNodes(updateNodes(nodes));
        }
    };

    // Function to update node label
    const updateNodeLabel = (id, newLabel) => {
        const updateNodes = (nodesList) => {
            return nodesList.map(node => {
                if (node.key === id) {
                    return { ...node, label: newLabel };
                }
                if (node.children && node.children.length > 0) {
                    return {
                        ...node,
                        children: updateNodes(node.children)
                    };
                }
                return node;
            });
        };
        setNodes(updateNodes(nodes));
    };

    // Function to delete a node
    const deleteNode = (id) => {
        const removeNode = (nodesList) => {
            return nodesList.filter(node => {
                if (node.key === id) {
                    return false;
                }
                if (node.children && node.children.length > 0) {
                    node.children = removeNode(node.children);
                }
                return true;
            });
        };
        setNodes(removeNode(nodes));
    };

    // Recursive component to render the tree structure
    const RenderNode = ({ node }) => {
        const [localLabel, setLocalLabel] = useState(node.label);

        const handleInputChange = (e) => {
            setLocalLabel(e.target.value); // Update local state
        };

        const handleInputBlur = () => {
            if (localLabel !== node.label) {
                updateNodeLabel(node.key, localLabel); // Update global state on blur
            }
        };

        return (
            <div className="ml-4">
                <div className="flex items-center gap-2 my-2">
                    <InputText
                        value={localLabel}
                        onChange={handleInputChange}
                        onBlur={handleInputBlur}
                        placeholder="Enter node label"
                        className="p-inputtext"
                    />
                    <Button
                        icon="pi pi-plus"
                        className="p-button-rounded p-button-success p-button-text"
                        onClick={() => createNode(node.key)}
                        tooltip="Add child node"
                    />
                    <Button
                        icon="pi pi-trash"
                        className="p-button-rounded p-button-danger p-button-text"
                        onClick={() => deleteNode(node.key)}
                        tooltip="Delete node"
                    />
                </div>
                {node.children && node.children.length > 0 && (
                    <div className="ml-4">
                        {node.children.map((childNode) => (
                            <RenderNode key={childNode.key} node={childNode} />
                        ))}
                    </div>
                )}
            </div>
        );
    };


    // Categories end

    // Groups start

    const [categoryNodes, setCategoryNodes] = useState([]);

    // Function to create a new category
    const createCategory = (parentCategoryId = null) => {
        const newCategory = {
            key: Date.now().toString(),
            label: '',
            parentCategoryId,
            children: []
        };

        if (!parentCategoryId) {
            setCategoryNodes([...categoryNodes, newCategory]);
        } else {
            const updateCategories = (categoriesList) => {
                return categoriesList.map(category => {
                    if (category.key === parentCategoryId) {
                        return {
                            ...category,
                            children: [...(category.children || []), newCategory]
                        };
                    }
                    if (category.children && category.children.length > 0) {
                        return {
                            ...category,
                            children: updateCategories(category.children)
                        };
                    }
                    return category;
                });
            };
            setCategoryNodes(updateCategories(categoryNodes));
        }
    };

    // Function to update category label
    const updateCategoryLabel = (id, newLabel) => {
        const updateCategories = (categoriesList) => {
            return categoriesList.map(category => {
                if (category.key === id) {
                    return { ...category, label: newLabel };
                }
                if (category.children && category.children.length > 0) {
                    return {
                        ...category,
                        children: updateCategories(category.children)
                    };
                }
                return category;
            });
        };
        setCategoryNodes(updateCategories(categoryNodes));
    };

    // Function to delete a category
    const deleteCategory = (id) => {
        const removeCategory = (categoriesList) => {
            return categoriesList.filter(category => {
                if (category.key === id) {
                    return false;
                }
                if (category.children && category.children.length > 0) {
                    category.children = removeCategory(category.children);
                }
                return true;
            });
        };
        setCategoryNodes(removeCategory(categoryNodes));
    };

    // Recursive component to render the category structure
    const RenderCategory = ({ category }) => {
        const [localCategoryLabel, setLocalCategoryLabel] = useState(category.label);

        const handleInputChange = (e) => {
            setLocalCategoryLabel(e.target.value); // Update local state
        };

        const handleInputBlur = () => {
            if (localCategoryLabel !== category.label) {
                updateCategoryLabel(category.key, localCategoryLabel); // Update global state on blur
            }
        };

        return (
            <div className="ml-4">
                <div className="flex items-center gap-2 my-2">
                    <InputText
                        value={localCategoryLabel}
                        onChange={handleInputChange}
                        onBlur={handleInputBlur}
                        placeholder="Enter category label"
                        className="p-inputtext"
                    />
                    <Button
                        icon="pi pi-plus"
                        className="p-button-rounded p-button-success p-button-text"
                        onClick={() => createCategory(category.key)}
                        tooltip="Add child category"
                    />
                    <Button
                        icon="pi pi-trash"
                        className="p-button-rounded p-button-danger p-button-text"
                        onClick={() => deleteCategory(category.key)}
                        tooltip="Delete category"
                    />
                </div>
                {category.children && category.children.length > 0 && (
                    <div className="ml-4">
                        {category.children.map((childCategory) => (
                            <RenderCategory key={childCategory.key} category={childCategory} />
                        ))}
                    </div>
                )}
            </div>
        );
    };

    return (
        <React.Fragment>
            <Container fluid={true}>
                <div className="admin-dash">

                    <div className="container-fluid mt-3">
                        {/* Conditional Rendering */}
                        {!selectedOption && (
                            <Row>
                                <Col xl={6}>
                                    <div
                                        className="user-box mt-2"
                                        onClick={() => setSelectedOption("general")}
                                        style={{
                                            cursor: "pointer",
                                            padding: "1rem",
                                            border: "1px solid #ccc",
                                            textAlign: "center",
                                        }}
                                    >
                                        <i className="pi pi-info-circle mr-2"></i>General
                                    </div>
                                </Col>

                                <Col xl={6}>
                                    <div
                                        className="user-box mt-2"
                                        onClick={() => setSelectedOption("email-settings")}
                                        style={{
                                            cursor: "pointer",
                                            padding: "1rem",
                                            border: "1px solid #ccc",
                                            textAlign: "center",
                                        }}
                                    >
                                        <i className="pi pi-envelope mr-2"></i>Email Settings
                                    </div>
                                </Col>

                                <Col xl={6}>
                                    <div
                                        className="user-box mt-2"
                                        onClick={() => setSelectedOption("sms-settings")}
                                        style={{
                                            cursor: "pointer",
                                            padding: "1rem",
                                            border: "1px solid #ccc",
                                            textAlign: "center",
                                        }}
                                    >
                                        <i className="pi pi-comment mr-2"></i>SMS Settings
                                    </div>
                                </Col>
                                <Col xl={6}>
                                    <div
                                        className="user-box mt-2"
                                        onClick={() => setSelectedOption("user-activity-alerts")}
                                    >
                                        <i className="pi pi-bell mr-2"></i>User Activity Alerts
                                    </div>
                                </Col>

                                <Col xl={6}>
                                    <div
                                        className="user-box mt-2"
                                        onClick={() => setSelectedOption("database-alerts")}
                                        style={{
                                            cursor: "pointer",
                                            padding: "1rem",
                                            border: "1px solid #ccc",
                                            textAlign: "center",
                                        }}
                                    >
                                        <i className="pi pi-database mr-2"></i>Database Alerts
                                    </div>
                                </Col>

                                <Col xl={6}>
                                    <div
                                        className="user-box mt-2"
                                        onClick={() => setSelectedOption("reports-alerts")}
                                        style={{
                                            cursor: "pointer",
                                            padding: "1rem",
                                            border: "1px solid #ccc",
                                            textAlign: "center",
                                        }}
                                    >
                                        <i className="pi pi-chart-bar mr-2"></i>Reports Alerts
                                    </div>
                                </Col>

                                <Col xl={6}>
                                    <div
                                        className="user-box mt-2"
                                        onClick={() => setSelectedOption("crons")}
                                    >
                                        <i className="pi pi-clock mr-2"></i>Crons / Triggers
                                    </div>
                                </Col>

                                <Col xl={6}>
                                    <div
                                        className="user-box mt-2"
                                        onClick={() => setSelectedOption("workflow")}
                                    >
                                        <i className="pi pi-sitemap mr-2"></i>Workflow
                                    </div>
                                </Col>

                                <Col xl={6}>
                                    <div
                                        className="user-box mt-2"
                                        onClick={() => setSelectedOption("integrations")}
                                        style={{
                                            cursor: "pointer",
                                            padding: "1rem",
                                            border: "1px solid #ccc",
                                            textAlign: "center",
                                        }}
                                    >
                                        <i className="pi pi-share-alt mr-2"></i>Integrations
                                    </div>
                                </Col>

                                <Col xl={6}>
                                    <div
                                        className="user-box mt-2"
                                        onClick={() => setSelectedOption("resume")}
                                        style={{
                                            cursor: "pointer",
                                            padding: "1rem",
                                            border: "1px solid #ccc",
                                            textAlign: "center",
                                        }}
                                    >
                                        <i className="pi pi-id-card mr-2"></i>Resume Branding
                                    </div>
                                </Col>

                                <Col xl={6}>
                                    <div
                                        className="user-box mt-2"
                                        onClick={() => setSelectedOption("storage")}
                                        style={{
                                            cursor: "pointer",
                                            padding: "1rem",
                                            border: "1px solid #ccc",
                                            textAlign: "center",
                                        }}
                                    >
                                        <i className="pi pi-cloud mr-2"></i>Storage
                                    </div>
                                </Col>

                                <Col xl={6}>
                                    <div
                                        className="user-box mt-2"
                                        onClick={() => setSelectedOption("schedule")}
                                        style={{
                                            cursor: "pointer",
                                            padding: "1rem",
                                            border: "1px solid #ccc",
                                            textAlign: "center",
                                        }}
                                    >
                                        <i className="pi pi-calendar mr-2"></i>Schedule
                                    </div>
                                </Col>

                            </Row>
                        )}

                        {/* PrimeReact user-activity-alerts */}
                        {selectedOption === "user-activity-alerts" && (
                            <div>
                                <div className="breadcrumb d-flex justify-content-between">
                                    <BreadCrumb model={breadGeneral} />

                                    <button
                                        className="p-button p-component mb-3"
                                        onClick={() => setSelectedOption(null)}
                                    >
                                        <i className="pi pi-arrow-left me-2"></i> Back
                                    </button>
                                </div>

                                <DataTable value={users} responsiveLayout="scroll">
                                    <Column
                                        field="username"
                                        header="Name"
                                        style={{ width: "20%" }}
                                    ></Column>
                                    <Column
                                        field="password"
                                        header="Email"
                                        style={{ width: "20%" }}
                                    ></Column>
                                    <Column
                                        field="userRole"
                                        header="User Role"
                                        style={{ width: "30%" }}
                                    ></Column>
                                    <Column
                                        field="status"
                                        header="Status"
                                        style={{ width: "15%" }}
                                    ></Column>
                                    <Column body={editIcon} style={{ width: "10%" }} />
                                    <Column body={deleteIcon} style={{ width: "10%" }} />
                                </DataTable>

                                {/* Dialog for editing user */}
                                <Dialog
                                    header="Edit User"
                                    visible={isDialogVisible}
                                    style={{ width: "30vw" }}
                                    onHide={() => setDialogVisible(false)}
                                >
                                    <div>
                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="title" className="block">
                                                    Username
                                                </label>
                                                <InputText
                                                    id="username"
                                                    value={selectedUser ? selectedUser.username : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            username: e.target.value,
                                                        })
                                                    }
                                                    className="w-full"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="Password" className="block">
                                                    Password
                                                </label>
                                                <InputText
                                                    id="password"
                                                    className="w-full"
                                                    value={selectedUser ? selectedUser.password : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            password: e.target.value,
                                                        })
                                                    }
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="status" className="block">
                                                    Status
                                                </label>
                                                <InputText
                                                    id="status"
                                                    value={selectedUser ? selectedUser.status : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            status: e.target.value,
                                                        })
                                                    }
                                                    className="w-full"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="userRole" className="block">
                                                    User Role
                                                </label>
                                                <InputText
                                                    id="userRole"
                                                    value={selectedUser ? selectedUser.userRole : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            userRole: e.target.value,
                                                        })
                                                    }
                                                    className="w-full"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="archive" className="block">
                                                    Archive
                                                </label>
                                                <InputText
                                                    id="archive"
                                                    value={
                                                        selectedUser
                                                            ? selectedUser.archive
                                                                ? "Yes"
                                                                : "No"
                                                            : ""
                                                    }
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            archive: e.target.value === "Yes",
                                                        })
                                                    }
                                                    className="w-full"
                                                />
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col xl={12}>
                                                <div className="d-flex justify-content-end mt-2">
                                                    <Button
                                                        color="primary btn-main me-2"
                                                        onClick={handleSave}
                                                    >
                                                        <i className="pi pi-check me-1"></i>
                                                        Ok
                                                    </Button>
                                                    <Button
                                                        color="btn btn-primary cancel-outlinebtn"
                                                        onClick={handleCancel}
                                                    >
                                                        <i className="pi pi-times me-1"></i>
                                                        Cancel
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* <Button label="Save" icon="pi pi-check" onClick={handleSave} />
                    <Button label="Cancel" icon="pi pi-times" className="p-button-secondary"  /> */}
                                    </div>
                                </Dialog>
                            </div>
                        )}

                        {/* Placeholder for database-alerts */}
                        {selectedOption === "database-alerts" && (
                            <div>
                                <div className="breadcrumb d-flex justify-content-between">
                                    <BreadCrumb model={breadDatabase} />

                                    <button
                                        className="p-button p-component mb-3"
                                        onClick={() => setSelectedOption(null)}
                                    >
                                        <i className="pi pi-arrow-left me-2"></i> Back
                                    </button>
                                </div>

                                <DataTable value={userRole} responsiveLayout="scroll">
                                    <Column
                                        field="password"
                                        header="Role name"
                                        style={{ width: "20%" }}
                                    ></Column>
                                    <Column
                                        field="username"
                                        header="Username"
                                        style={{ width: "20%" }}
                                    ></Column>

                                    <Column body={editIcon} style={{ width: "10%" }} />
                                    {/* <Column body={viewIcon} style={{ width: "10%" }} /> */}
                                </DataTable>

                                {/* Dialog for editing user */}
                                <Dialog
                                    header="Edit User"
                                    visible={isDialogVisible}
                                    style={{ width: "30vw" }}
                                    onHide={() => setDialogVisible(false)}
                                >
                                    <div>
                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="Password" className="block">
                                                    Role Name
                                                </label>
                                                <InputText
                                                    id="password"
                                                    className="w-full"
                                                    value={selectedUser ? selectedUser.password : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            password: e.target.value,
                                                        })
                                                    }
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="title" className="block">
                                                    Username
                                                </label>
                                                <InputText
                                                    id="username"
                                                    value={selectedUser ? selectedUser.username : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            username: e.target.value,
                                                        })
                                                    }
                                                    className="w-full"
                                                />
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col xl={12}>
                                                <div className="d-flex justify-content-end mt-2">
                                                    <Button
                                                        color="primary btn-main me-2"
                                                        onClick={handleSave}
                                                    >
                                                        <i className="pi pi-check me-1"></i>
                                                        Ok
                                                    </Button>
                                                    <Button
                                                        color="btn btn-primary cancel-outlinebtn"
                                                        onClick={handleCancel}
                                                    >
                                                        <i className="pi pi-times me-1"></i>
                                                        Cancel
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* <Button label="Save" icon="pi pi-check" onClick={handleSave} />
                    <Button label="Cancel" icon="pi pi-times" className="p-button-secondary"  /> */}
                                    </div>
                                </Dialog>
                            </div>
                        )}

                        {/* Placeholder for reports-alerts */}
                        {selectedOption === "reports-alerts" && (
                            <div>
                                <div className="breadcrumb d-flex justify-content-between">
                                    <BreadCrumb model={breadDatabase} />

                                    <button
                                        className="p-button p-component mb-3"
                                        onClick={() => setSelectedOption(null)}
                                    >
                                        <i className="pi pi-arrow-left me-2"></i> Back
                                    </button>
                                </div>

                                <DataTable value={userRole} responsiveLayout="scroll">
                                    <Column
                                        field="password"
                                        header="Group Name"
                                        style={{ width: "20%" }}
                                    ></Column>
                                    <Column
                                        field="username"
                                        header="Users name"
                                        style={{ width: "20%" }}
                                    ></Column>

                                    <Column
                                        field="username"
                                        header="Role"
                                        style={{ width: "20%" }}
                                    ></Column>

                                    <Column body={editIcon} style={{ width: "10%" }} />
                                    {/* <Column body={viewIcon} style={{ width: "10%" }} /> */}
                                </DataTable>

                                {/* Dialog for editing user */}
                                <Dialog
                                    header="Edit User"
                                    visible={isDialogVisible}
                                    style={{ width: "30vw" }}
                                    onHide={() => setDialogVisible(false)}
                                >
                                    <div>
                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="Password" className="block">
                                                    Group Name
                                                </label>
                                                <InputText
                                                    id="password"
                                                    className="w-full"
                                                    value={selectedUser ? selectedUser.password : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            password: e.target.value,
                                                        })
                                                    }
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="title" className="block">
                                                    Users name
                                                </label>
                                                <InputText
                                                    id="username"
                                                    value={selectedUser ? selectedUser.username : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            username: e.target.value,
                                                        })
                                                    }
                                                    className="w-full"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="title" className="block">
                                                    Role
                                                </label>
                                                <InputText
                                                    id="username"
                                                    value={selectedUser ? selectedUser.username : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            username: e.target.value,
                                                        })
                                                    }
                                                    className="w-full"
                                                />
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col xl={12}>
                                                <div className="d-flex justify-content-end mt-2">
                                                    <Button
                                                        color="primary btn-main me-2"
                                                        onClick={handleSave}
                                                    >
                                                        <i className="pi pi-check me-1"></i>
                                                        Ok
                                                    </Button>
                                                    <Button
                                                        color="btn btn-primary cancel-outlinebtn"
                                                        onClick={handleCancel}
                                                    >
                                                        <i className="pi pi-times me-1"></i>
                                                        Cancel
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* <Button label="Save" icon="pi pi-check" onClick={handleSave} />
                   <Button label="Cancel" icon="pi pi-times" className="p-button-secondary"  /> */}
                                    </div>
                                </Dialog>
                            </div>
                        )}

                        {/* Placeholder for crons */}
                        {selectedOption === "crons" && (
                            <div>
                                <div className="breadcrumb d-flex justify-content-between">
                                    <BreadCrumb model={breadItems} />

                                    <button
                                        className="p-button p-component mb-3"
                                        onClick={() => setSelectedOption(null)}
                                    >
                                        <i className="pi pi-arrow-left me-2"></i> Back
                                    </button>
                                </div>

                                <DataTable value={userRole} responsiveLayout="scroll">
                                    <Column
                                        field="password"
                                        header="Group Name"
                                        style={{ width: "20%" }}
                                    ></Column>
                                    <Column
                                        field="username"
                                        header="Users name"
                                        style={{ width: "20%" }}
                                    ></Column>

                                    <Column
                                        field="username"
                                        header="Role"
                                        style={{ width: "20%" }}
                                    ></Column>

                                    <Column body={editIcon} style={{ width: "10%" }} />
                                    {/* <Column body={viewIcon} style={{ width: "10%" }} /> */}
                                </DataTable>

                                {/* Dialog for editing user */}
                                <Dialog
                                    header="Edit User"
                                    visible={isDialogVisible}
                                    style={{ width: "30vw" }}
                                    onHide={() => setDialogVisible(false)}
                                >
                                    <div>
                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="Password" className="block">
                                                    Group Name
                                                </label>
                                                <InputText
                                                    id="password"
                                                    className="w-full"
                                                    value={selectedUser ? selectedUser.password : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            password: e.target.value,
                                                        })
                                                    }
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="title" className="block">
                                                    Users name
                                                </label>
                                                <InputText
                                                    id="username"
                                                    value={selectedUser ? selectedUser.username : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            username: e.target.value,
                                                        })
                                                    }
                                                    className="w-full"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="title" className="block">
                                                    Role
                                                </label>
                                                <InputText
                                                    id="username"
                                                    value={selectedUser ? selectedUser.username : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            username: e.target.value,
                                                        })
                                                    }
                                                    className="w-full"
                                                />
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col xl={12}>
                                                <div className="d-flex justify-content-end mt-2">
                                                    <Button
                                                        color="primary btn-main me-2"
                                                        onClick={handleSave}
                                                    >
                                                        <i className="pi pi-check me-1"></i>
                                                        Ok
                                                    </Button>
                                                    <Button
                                                        color="btn btn-primary cancel-outlinebtn"
                                                        onClick={handleCancel}
                                                    >
                                                        <i className="pi pi-times me-1"></i>
                                                        Cancel
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* <Button label="Save" icon="pi pi-check" onClick={handleSave} />
                   <Button label="Cancel" icon="pi pi-times" className="p-button-secondary"  /> */}
                                    </div>
                                </Dialog>
                            </div>
                        )}

                        {/* Placeholder for workflow */}
                        {selectedOption === "workflow" && (
                            <div>
                                <div className="breadcrumb d-flex justify-content-between">
                                    <BreadCrumb model={breadItems} />

                                    <button
                                        className="p-button p-component mb-3"
                                        onClick={() => setSelectedOption(null)}
                                    >
                                        <i className="pi pi-arrow-left me-2"></i> Back
                                    </button>
                                </div>

                                <DataTable value={userRole} responsiveLayout="scroll">
                                    <Column
                                        field="password"
                                        header="Group Name"
                                        style={{ width: "20%" }}
                                    ></Column>
                                    <Column
                                        field="username"
                                        header="Users name"
                                        style={{ width: "20%" }}
                                    ></Column>

                                    <Column
                                        field="username"
                                        header="Role"
                                        style={{ width: "20%" }}
                                    ></Column>

                                    <Column body={editIcon} style={{ width: "10%" }} />
                                    {/* <Column body={viewIcon} style={{ width: "10%" }} /> */}
                                </DataTable>

                                {/* Dialog for editing user */}
                                <Dialog
                                    header="Edit User"
                                    visible={isDialogVisible}
                                    style={{ width: "30vw" }}
                                    onHide={() => setDialogVisible(false)}
                                >
                                    <div>
                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="Password" className="block">
                                                    Group Name
                                                </label>
                                                <InputText
                                                    id="password"
                                                    className="w-full"
                                                    value={selectedUser ? selectedUser.password : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            password: e.target.value,
                                                        })
                                                    }
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="title" className="block">
                                                    Users name
                                                </label>
                                                <InputText
                                                    id="username"
                                                    value={selectedUser ? selectedUser.username : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            username: e.target.value,
                                                        })
                                                    }
                                                    className="w-full"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="title" className="block">
                                                    Role
                                                </label>
                                                <InputText
                                                    id="username"
                                                    value={selectedUser ? selectedUser.username : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            username: e.target.value,
                                                        })
                                                    }
                                                    className="w-full"
                                                />
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col xl={12}>
                                                <div className="d-flex justify-content-end mt-2">
                                                    <Button
                                                        color="primary btn-main me-2"
                                                        onClick={handleSave}
                                                    >
                                                        <i className="pi pi-check me-1"></i>
                                                        Ok
                                                    </Button>
                                                    <Button
                                                        color="btn btn-primary cancel-outlinebtn"
                                                        onClick={handleCancel}
                                                    >
                                                        <i className="pi pi-times me-1"></i>
                                                        Cancel
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* <Button label="Save" icon="pi pi-check" onClick={handleSave} />
                   <Button label="Cancel" icon="pi pi-times" className="p-button-secondary"  /> */}
                                    </div>
                                </Dialog>
                            </div>
                        )}

                        {/* Placeholder for integrations */}
                        {selectedOption === "integrations" && (
                            <div>
                                <div className="breadcrumb d-flex justify-content-between">
                                    <BreadCrumb model={breadItems} />

                                    <button
                                        className="p-button p-component mb-3"
                                        onClick={() => setSelectedOption(null)}
                                    >
                                        <i className="pi pi-arrow-left me-2"></i> Back
                                    </button>
                                </div>

                                <DataTable value={userRole} responsiveLayout="scroll">
                                    <Column
                                        field="password"
                                        header="Group Name"
                                        style={{ width: "20%" }}
                                    ></Column>
                                    <Column
                                        field="username"
                                        header="Users name"
                                        style={{ width: "20%" }}
                                    ></Column>

                                    <Column
                                        field="username"
                                        header="Role"
                                        style={{ width: "20%" }}
                                    ></Column>

                                    <Column body={editIcon} style={{ width: "10%" }} />
                                    {/* <Column body={viewIcon} style={{ width: "10%" }} /> */}
                                </DataTable>

                                {/* Dialog for editing user */}
                                <Dialog
                                    header="Edit User"
                                    visible={isDialogVisible}
                                    style={{ width: "30vw" }}
                                    onHide={() => setDialogVisible(false)}
                                >
                                    <div>
                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="Password" className="block">
                                                    Group Name
                                                </label>
                                                <InputText
                                                    id="password"
                                                    className="w-full"
                                                    value={selectedUser ? selectedUser.password : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            password: e.target.value,
                                                        })
                                                    }
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="title" className="block">
                                                    Users name
                                                </label>
                                                <InputText
                                                    id="username"
                                                    value={selectedUser ? selectedUser.username : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            username: e.target.value,
                                                        })
                                                    }
                                                    className="w-full"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="title" className="block">
                                                    Role
                                                </label>
                                                <InputText
                                                    id="username"
                                                    value={selectedUser ? selectedUser.username : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            username: e.target.value,
                                                        })
                                                    }
                                                    className="w-full"
                                                />
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col xl={12}>
                                                <div className="d-flex justify-content-end mt-2">
                                                    <Button
                                                        color="primary btn-main me-2"
                                                        onClick={handleSave}
                                                    >
                                                        <i className="pi pi-check me-1"></i>
                                                        Ok
                                                    </Button>
                                                    <Button
                                                        color="btn btn-primary cancel-outlinebtn"
                                                        onClick={handleCancel}
                                                    >
                                                        <i className="pi pi-times me-1"></i>
                                                        Cancel
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* <Button label="Save" icon="pi pi-check" onClick={handleSave} />
                   <Button label="Cancel" icon="pi pi-times" className="p-button-secondary"  /> */}
                                    </div>
                                </Dialog>
                            </div>
                        )}

                        {/* Placeholder for resume */}
                        {selectedOption === "resume" && (
                            <div>
                                <div className="breadcrumb d-flex justify-content-between">
                                    <BreadCrumb model={breadItems} />

                                    <button
                                        className="p-button p-component mb-3"
                                        onClick={() => setSelectedOption(null)}
                                    >
                                        <i className="pi pi-arrow-left me-2"></i> Back
                                    </button>
                                </div>

                                <DataTable value={userRole} responsiveLayout="scroll">
                                    <Column
                                        field="password"
                                        header="Group Name"
                                        style={{ width: "20%" }}
                                    ></Column>
                                    <Column
                                        field="username"
                                        header="Users name"
                                        style={{ width: "20%" }}
                                    ></Column>

                                    <Column
                                        field="username"
                                        header="Role"
                                        style={{ width: "20%" }}
                                    ></Column>

                                    <Column body={editIcon} style={{ width: "10%" }} />
                                    {/* <Column body={viewIcon} style={{ width: "10%" }} /> */}
                                </DataTable>

                                {/* Dialog for editing user */}
                                <Dialog
                                    header="Edit User"
                                    visible={isDialogVisible}
                                    style={{ width: "30vw" }}
                                    onHide={() => setDialogVisible(false)}
                                >
                                    <div>
                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="Password" className="block">
                                                    Group Name
                                                </label>
                                                <InputText
                                                    id="password"
                                                    className="w-full"
                                                    value={selectedUser ? selectedUser.password : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            password: e.target.value,
                                                        })
                                                    }
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="title" className="block">
                                                    Users name
                                                </label>
                                                <InputText
                                                    id="username"
                                                    value={selectedUser ? selectedUser.username : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            username: e.target.value,
                                                        })
                                                    }
                                                    className="w-full"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="title" className="block">
                                                    Role
                                                </label>
                                                <InputText
                                                    id="username"
                                                    value={selectedUser ? selectedUser.username : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            username: e.target.value,
                                                        })
                                                    }
                                                    className="w-full"
                                                />
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col xl={12}>
                                                <div className="d-flex justify-content-end mt-2">
                                                    <Button
                                                        color="primary btn-main me-2"
                                                        onClick={handleSave}
                                                    >
                                                        <i className="pi pi-check me-1"></i>
                                                        Ok
                                                    </Button>
                                                    <Button
                                                        color="btn btn-primary cancel-outlinebtn"
                                                        onClick={handleCancel}
                                                    >
                                                        <i className="pi pi-times me-1"></i>
                                                        Cancel
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* <Button label="Save" icon="pi pi-check" onClick={handleSave} />
                   <Button label="Cancel" icon="pi pi-times" className="p-button-secondary"  /> */}
                                    </div>
                                </Dialog>
                            </div>
                        )}

                        {/* Placeholder for storage */}
                        {selectedOption === "storage" && (
                            <div className="storage">
                                <div className="breadcrumb d-flex justify-content-between">
                                    <BreadCrumb model={breadItems} />

                                    <button
                                        className="p-button p-component mb-3"
                                        onClick={() => setSelectedOption(null)}
                                    >
                                        <i className="pi pi-arrow-left me-2"></i> Back
                                    </button>
                                </div>

                                <Row>
                                    <Col xl={2}>
                                        <img src={gdrive} />
                                    </Col>

                                    <Col xl={2}>
                                        <img src={dropbox} />
                                    </Col>

                                    <Col xl={2}>
                                        <img src={onedrive} />
                                    </Col>
                                </Row>
                            </div>
                        )}

                        {/* Placeholder for schedule */}
                        {selectedOption === "schedule" && (
                            <div>
                                <div className="breadcrumb d-flex justify-content-between">
                                    <BreadCrumb model={breadItems} />

                                    <button
                                        className="p-button p-component mb-3"
                                        onClick={() => setSelectedOption(null)}
                                    >
                                        <i className="pi pi-arrow-left me-2"></i> Back
                                    </button>
                                </div>

                                <DataTable value={userRole} responsiveLayout="scroll">
                                    <Column
                                        field="password"
                                        header="Group Name"
                                        style={{ width: "20%" }}
                                    ></Column>
                                    <Column
                                        field="username"
                                        header="Users name"
                                        style={{ width: "20%" }}
                                    ></Column>

                                    <Column
                                        field="username"
                                        header="Role"
                                        style={{ width: "20%" }}
                                    ></Column>

                                    <Column body={editIcon} style={{ width: "10%" }} />
                                    {/* <Column body={viewIcon} style={{ width: "10%" }} /> */}
                                </DataTable>

                                {/* Dialog for editing user */}
                                <Dialog
                                    header="Edit User"
                                    visible={isDialogVisible}
                                    style={{ width: "30vw" }}
                                    onHide={() => setDialogVisible(false)}
                                >
                                    <div>
                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="Password" className="block">
                                                    Group Name
                                                </label>
                                                <InputText
                                                    id="password"
                                                    className="w-full"
                                                    value={selectedUser ? selectedUser.password : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            password: e.target.value,
                                                        })
                                                    }
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="title" className="block">
                                                    Users name
                                                </label>
                                                <InputText
                                                    id="username"
                                                    value={selectedUser ? selectedUser.username : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            username: e.target.value,
                                                        })
                                                    }
                                                    className="w-full"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-2">
                                            <Col xl={12}>
                                                <label htmlFor="title" className="block">
                                                    Role
                                                </label>
                                                <InputText
                                                    id="username"
                                                    value={selectedUser ? selectedUser.username : ""}
                                                    onChange={e =>
                                                        setSelectedUser({
                                                            ...selectedUser,
                                                            username: e.target.value,
                                                        })
                                                    }
                                                    className="w-full"
                                                />
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col xl={12}>
                                                <div className="d-flex justify-content-end mt-2">
                                                    <Button
                                                        color="primary btn-main me-2"
                                                        onClick={handleSave}
                                                    >
                                                        <i className="pi pi-check me-1"></i>
                                                        Ok
                                                    </Button>
                                                    <Button
                                                        color="btn btn-primary cancel-outlinebtn"
                                                        onClick={handleCancel}
                                                    >
                                                        <i className="pi pi-times me-1"></i>
                                                        Cancel
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* <Button label="Save" icon="pi pi-check" onClick={handleSave} />
                   <Button label="Cancel" icon="pi pi-times" className="p-button-secondary"  /> */}
                                    </div>
                                </Dialog>
                            </div>
                        )}

                        {/* Placeholder for general */}
                        {selectedOption === "general" && (
                            <div>
                                <div className="breadcrumb d-flex justify-content-between">
                                    <BreadCrumb model={breadItems} />

                                    <button
                                        className="p-button p-component mb-3"
                                        onClick={() => setSelectedOption(null)}
                                    >
                                        <i className="pi pi-arrow-left me-2"></i> Back
                                    </button>
                                </div>

                                <Row className="mt-3">
                                    <Col lg={4} sm={12}>
                                        <div className="p-field">
                                            <label>Font Size</label>
                                            <Dropdown
                                                value={fontSize}
                                                onChange={e => setFontSize(e.value)}
                                                options={fontSizeOptions}
                                                optionLabel="label"
                                                placeholder="Select Font Size"
                                                className="bgclr w-full"
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={4} sm={12}>
                                        <label>Default Folder</label>
                                        <Dropdown
                                            value={selectedFolder}
                                            onChange={e => setSelectedFolder(e.value)}
                                            options={folderOptions}
                                            optionLabel="label"
                                            placeholder="Select a Folder"
                                            className="bgclr w-full"
                                            itemTemplate={customTemplate}
                                        />
                                    </Col>
                                    <Col lg={4} sm={12}>
                                        <label>Default View</label>
                                        <Dropdown
                                            value={selectedView}
                                            onChange={e => setSelectedView(e.value)}
                                            options={viewOptions}
                                            optionLabel="label"
                                            placeholder="Select a Default View"
                                            className="bgclr w-full"
                                        />
                                    </Col>
                                </Row>
                            </div>
                        )}

                        {/* Placeholder for email-settings */}
                        {selectedOption === "email-settings" && (
                            <div>
                                <div className="breadcrumb d-flex justify-content-between">
                                    <BreadCrumb model={breadItems} />

                                    <button
                                        className="p-button p-component mb-3"
                                        onClick={() => setSelectedOption(null)}
                                    >
                                        <i className="pi pi-arrow-left me-2"></i> Back
                                    </button>
                                </div>

                                <Row>
                                    <Col lg={12}>
                                        <p className="mb-3 mt-2">
                                            Default Email Field for Mass Mailing or Email Campaigns
                                        </p>
                                        <div className="flex flex-wrap gap-3">
                                            <div className="flex align-items-center">
                                                <RadioButton
                                                    inputId="ingredient1"
                                                    name="pizza"
                                                    value="Cheese"
                                                    onChange={e => setIngredient(e.value)}
                                                    checked={ingredient === "Cheese"}
                                                />
                                                <label htmlFor="ingredient1" className="ml-2 mb-0">
                                                    Email1
                                                </label>
                                            </div>
                                            <div className="flex align-items-center">
                                                <RadioButton
                                                    inputId="ingredient2"
                                                    name="pizza"
                                                    value="Mushroom"
                                                    onChange={e => setIngredient(e.value)}
                                                    checked={ingredient === "Mushroom"}
                                                />
                                                <label htmlFor="ingredient2" className="ml-2 mb-0">
                                                    Email2
                                                </label>
                                            </div>
                                            <div className="flex align-items-center">
                                                <RadioButton
                                                    inputId="ingredient3"
                                                    name="pizza"
                                                    value="Pepper"
                                                    onChange={e => setIngredient(e.value)}
                                                    checked={ingredient === "Pepper"}
                                                />
                                                <label htmlFor="ingredient3" className="ml-2 mb-0">
                                                    Email1 or Email2
                                                </label>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <h6 className="mb-3 mt-4">SMTP Email Accounts</h6>
                                        <Row className="mb-3">
                                            <Col lg={2}>
                                                <Button
                                                    color="primary"
                                                    className="btn btn-primary outlinebtn d-block"
                                                >
                                                    <i className="pi pi-plus me-1"></i>
                                                    Add SMTP
                                                </Button>
                                            </Col>
                                            <Col lg={10} className="m-0">
                                                <InputText
                                                    value={addsmtp}
                                                    onChange={e => setAddsmtp(e.target.value)}
                                                    className="w-full"
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <DataTable
                                            value={smtpAccounts}
                                            showGridlines
                                            tableStyle={{ minWidth: "50rem" }}
                                        >
                                            <Column
                                                field="outgoingServer"
                                                header="Outgoing Server"
                                            ></Column>
                                            <Column field="port" header="Port"></Column>
                                            <Column field="username" header="Username"></Column>
                                            <Column field="password" header="Password"></Column>
                                            <Column field="email" header="Email"></Column>
                                            <Column field="address" header="Address"></Column>
                                        </DataTable>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <div className="card p-4 pt-0 pb-4 mt-2">
                                            <h6 className="mb-2 mt-4">SMTP Account</h6>
                                            <Row>
                                                <Col lg={9}>
                                                    <div className="p-field mb-2">
                                                        <label>Outgoing Server</label>
                                                        <InputText
                                                            id="outgoingServer"
                                                            value={outgoingServer}
                                                            onChange={e => setOutgoingServer(e.target.value)}
                                                            placeholder="e.g., smtp.example.com"
                                                            required
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </Col>
                                                <Col lg={3}>
                                                    <div className="p-field mb-2">
                                                        <label htmlFor="port">Port</label>
                                                        <InputText
                                                            id="port"
                                                            value={port}
                                                            onChange={e => setPort(e.target.value)}
                                                            placeholder="Enter port number"
                                                            type="number"
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={6}>
                                                    <div className="p-field mb-2">
                                                        <label>Username</label>
                                                        <InputText
                                                            id="username"
                                                            value={username}
                                                            onChange={e => setUsername(e.target.value)}
                                                            placeholder="SMTP username"
                                                            required
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </Col>
                                                <Col lg={6}>
                                                    <div className="p-field mb-2">
                                                        <label>Password</label>
                                                        <InputText
                                                            id="password"
                                                            type="password"
                                                            value={password}
                                                            onChange={e => setPassword(e.target.value)}
                                                            placeholder="SMTP password"
                                                            required
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={6}>
                                                    <div className="p-field mb-2">
                                                        <label>From</label>
                                                        <InputText
                                                            id="fromEmail"
                                                            value={fromEmail}
                                                            onChange={e => setFromEmail(e.target.value)}
                                                            placeholder="e.g., no-reply@example.com"
                                                            required
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </Col>
                                                <Col lg={6}>
                                                    <div className="p-field mb-2">
                                                        <label>Email</label>
                                                        <InputText
                                                            id="email"
                                                            value={email}
                                                            onChange={e => setEmail(e.target.value)}
                                                            placeholder="Enter your email"
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row className="d-flex align-items-end">
                                                <Col lg={9}>
                                                    <div className="p-field">
                                                        <label htmlFor="address">Reply Address</label>
                                                        <InputText
                                                            id="address"
                                                            value={address}
                                                            onChange={e => setAddress(e.target.value)}
                                                            placeholder="Enter address"
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </Col>
                                                <Col lg={3}>
                                                    <div className="field-checkbox">
                                                        <Checkbox
                                                            onChange={e => setUseSSL(e.checked)}
                                                            checked={useSSL}
                                                        />
                                                        <label htmlFor="useSSL" className="ml-2">
                                                            Use SSL/TLS
                                                        </label>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row className="align-items-center mt-3">
                                                <Col md={12}>
                                                    <div className="d-flex justify-content-end">
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-main me-2"
                                                            onClick={handleCreate}
                                                        >
                                                            <i className="pi pi-check me-1"></i>Create
                                                        </button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                        <Row className="align-items-center mt-3">
                                            <Col md={12}>
                                                <div className="d-flex justify-content-end">
                                                    <button
                                                        type="submit"
                                                        class="btn btn-primary  btn-main me-2"
                                                    >
                                                        {" "}
                                                        <i className="pi pi-save me-1"></i>Save
                                                    </button>
                                                    <button
                                                        type="button"
                                                        class="btn btn-primary  cancel-outlinebtn"
                                                    >
                                                        {" "}
                                                        <i className="pi pi-times me-1"></i>Cancel
                                                    </button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        )}

                        {/* Placeholder for sms-settings */}
                        {selectedOption === "sms-settings" && (
                            <div>
                                <div className="breadcrumb d-flex justify-content-between">
                                    <BreadCrumb model={breadItems} />

                                    <button
                                        className="p-button p-component mb-3"
                                        onClick={() => setSelectedOption(null)}
                                    >
                                        <i className="pi pi-arrow-left me-2"></i> Back
                                    </button>
                                </div>

                                <TabPanel header="SMS Settings" leftIcon="pi pi-comment mr-2">
                                    <Row>
                                        <Col lg={8}>
                                            <h6 className="mb-2 mt-3">
                                                BANDWIDTH SMS(FOR INDIVIDUAL TEXTING)
                                            </h6>
                                            <div className="d-flex align-items-end">
                                                <div className="p-field me-2">
                                                    <label htmlFor="areaCode">Area Code</label>
                                                    <InputText
                                                        id="areaCode"
                                                        value={areaCode}
                                                        onChange={e => setAreaCode(e.target.value)}
                                                        placeholder="Enter area code"
                                                        maxLength={5}
                                                        className="w-full"
                                                    />
                                                </div>
                                                <div>
                                                    <Button
                                                        color="primary"
                                                        className="btn btn-primary outlinebtn d-block"
                                                    >
                                                        <i className="pi pi-search me-1"></i>
                                                        Search
                                                    </Button>
                                                </div>
                                            </div>
                                            <p className="mt-2">
                                                Please, search for area code to view available numbers.
                                            </p>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col lg={8}>
                                            <h6 className="mb-2 mt-4">SWIFT SMS(FOR MASS TEXTING)</h6>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col lg={6}>
                                            <div className="field">
                                                <label htmlFor="accountKey">Account Key</label>
                                                <InputText
                                                    id="accountKey"
                                                    type="password"
                                                    value={accountKey}
                                                    onChange={e => setAccountKey(e.target.value)}
                                                    placeholder="Enter your account key"
                                                    className="w-full"
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={6}>
                                            <div className="field">
                                                <label htmlFor="phoneNumber">
                                                    Senders Phone Number
                                                </label>
                                                <InputText
                                                    id="phoneNumber"
                                                    type="tel"
                                                    value={phoneNumber}
                                                    onChange={e => setPhoneNumber(e.target.value)}
                                                    placeholder="Enter your phone number"
                                                    className="w-full"
                                                />
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row className="align-items-center mt-3">
                                        <Col md={12}>
                                            <div className="d-flex justify-content-end">
                                                <button
                                                    type="submit"
                                                    class="btn btn-primary  btn-main me-2"
                                                >
                                                    {" "}
                                                    <i className="pi pi-save me-1"></i>Save
                                                </button>
                                                <button
                                                    type="button"
                                                    class="btn btn-primary  cancel-outlinebtn"
                                                >
                                                    {" "}
                                                    <i className="pi pi-times me-1"></i>Cancel
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>
                                </TabPanel>
                            </div>
                        )}

                        {/* Placeholder for sms-settings */}
                        {selectedOption === "sms-settings" && (
                            <div>
                                {/* <div className="breadcrumb d-flex justify-content-between">
                  <BreadCrumb model={breadItems} />

                  <button
                    className="p-button p-component mb-3"
                    onClick={() => setSelectedOption(null)}
                  >
                    <i className="pi pi-arrow-left me-2"></i> Back
                  </button>
                </div> */}

                                <Row>
                                    <Col lg={8}>
                                        <h6 className="mb-2 mt-2">
                                            BANDWIDTH SMS(FOR INDIVIDUAL TEXTING)
                                        </h6>
                                        <div className="d-flex align-items-end">
                                            <div className="p-field me-2">
                                                <label htmlFor="areaCode">Area Code</label>
                                                <InputText
                                                    id="areaCode"
                                                    value={areaCode}
                                                    onChange={e => setAreaCode(e.target.value)}
                                                    placeholder="Enter area code"
                                                    maxLength={5}
                                                    className="w-full"
                                                />
                                            </div>
                                            <div>
                                                <Button
                                                    color="primary"
                                                    className="btn btn-primary outlinebtn d-block"
                                                >
                                                    <i className="pi pi-search me-1"></i>
                                                    Search
                                                </Button>
                                            </div>
                                        </div>
                                        <p className="mt-2">
                                            Please, search for area code to view available numbers.
                                        </p>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg={8}>
                                        <h6 className="mb-2 mt-4">SWIFT SMS(FOR MASS TEXTING)</h6>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg={6}>
                                        <div className="field">
                                            <label htmlFor="accountKey">Account Key</label>
                                            <InputText
                                                id="accountKey"
                                                type="password"
                                                value={accountKey}
                                                onChange={e => setAccountKey(e.target.value)}
                                                placeholder="Enter your account key"
                                                className="w-full"
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="field">
                                            <label htmlFor="phoneNumber">Senders Phone Number</label>
                                            <InputText
                                                id="phoneNumber"
                                                type="tel"
                                                value={phoneNumber}
                                                onChange={e => setPhoneNumber(e.target.value)}
                                                placeholder="Enter your phone number"
                                                className="w-full"
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                <Row className="align-items-center mt-3">
                                    <Col md={12}>
                                        <div className="d-flex justify-content-end">
                                            <button
                                                type="submit"
                                                class="btn btn-primary  btn-main me-2"
                                            >
                                                {" "}
                                                <i className="pi pi-save me-1"></i>Save
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn-primary  cancel-outlinebtn"
                                            >
                                                {" "}
                                                <i className="pi pi-times me-1"></i>Cancel
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        )}

                    </div>

                </div >
            </Container >
        </React.Fragment >

    )
}

export default Settingadm
